import { TranslationKeys } from '@/localization';
import { toRuntimeTranslationKey } from '@/localization/translationKey';
import { DataSource } from '@/models/dataSource';
import { FC } from 'react';

import SyncIcon from '@/assets/icons/refresh.svg?react';
import { IconButton } from '@/lib';
import { useTranslation } from 'react-i18next';
import { ResyncDataSourceModal } from '@/features/dataSourceDetails/components/tabs/settings/modals';
import { useModalContext } from '@/hooks/useModalContext';

type DataSourceDownloadButtonProps = {
  dataSource: DataSource;
  buttonText?: TranslationKeys;
};

export const DataSourceResyncButton: FC<DataSourceDownloadButtonProps> = ({ dataSource, buttonText }) => {
  const { t } = useTranslation();
  const { openModal } = useModalContext();

  const handleResyncClick = () => {
    openModal({
      renderContent: ResyncDataSourceModal,
      renderContentProps: {
        dataSource: dataSource,
      },
      dismissable: true,
      fullWidth: false,
      fullHeight: false,
    });
  };
  
  return (
    <IconButton
      intent='link-grey'
      className='!p-1.5 text-tertiary-600'
      text={buttonText ? t(toRuntimeTranslationKey(buttonText) as any) : undefined}
      leadingIcon={<SyncIcon className='text-quaternary-400' />}
      disabled={false}
      onClick={handleResyncClick}
    />
  );
};
